function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import BulkUnpairFlow from "../views/bulk/BulkUnpairFlow.js";
const {
  tf,
  t
} = I18N.ns('pairing.bulkPairing.actions.bulkUnpair');
export default ({
  path,
  parentBlueprint,
  blueprint
}) => {
  const parentObjectName = parentBlueprint?.name;
  const objectName = blueprint?.name;
  const parentObjectType = parentBlueprint?.type;
  const objectType = blueprint?.type;
  const parentNetworkId = parentBlueprint?.model?.tags?.find(tag => tag?.startsWith('network:'));
  const parentNetwork = parentNetworkId?.split(':')[1];
  const parentNetworkIdentifier = parentNetworkId?.split(':')[2];
  return {
    id: `api-pairing.${path}.bulkUnpair`,
    name: tf('name', {
      objectName,
      parentObjectName
    }),
    appearance: ({
      context,
      action
    }) => {
      return {
        name: t('appearanceName')
      };
    },
    perform: props => {
      const {
        context
      } = props;
      const {
        clientProps
      } = context;
      const {
        actions
      } = clientProps;
      Dialogs.show({
        component: cProps => {
          return /*#__PURE__*/React.createElement(BulkUnpairFlow, _extends({
            settingsPath: `api-pairing.${path}.bulkUnpair`,
            parentNetwork: parentNetwork,
            parentNetworkIdentifier: parentNetworkIdentifier,
            actions: actions,
            parentObjectName: parentObjectName,
            parentObjectType: parentObjectType,
            objectType: objectType
          }, cProps));
        }
      });
    }
  };
};